import { Button, Dialog, Group, Stack, ThemeIcon } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { pushSubscribeStore } from 'stores/global/RootStore';

import Text from '../Text';

const PushSubscribeModal: React.FC = () => {
  const { modal, trySubscribe, canSubscribe } = pushSubscribeStore;

  React.useEffect(() => {
    pushSubscribeStore.initSubscribe();
  }, [canSubscribe]);

  if (!canSubscribe) {
    return null;
  }

  return (
    <Dialog
      position={{
        top: 10,
        left: 10,
      }}
      opened={modal.isOpen}
      withCloseButton
      onClose={modal.close}
    >
      <Group gap="sm" wrap="nowrap" align="flex-start">
        <ThemeIcon size="md" variant="outline">
          <IconBell size={16} />
        </ThemeIcon>
        <Stack>
          <Text fw={600} size="sm">
            Чтобы получать уведомления в личном кабинете, подпишитесь
          </Text>
          <Group gap="xs">
            <Button size="xs" onClick={trySubscribe}>
              Подписаться
            </Button>
            <Button variant="light" size="xs" onClick={modal.close}>
              Позже
            </Button>
          </Group>
        </Stack>
      </Group>
    </Dialog>
  );
};

export default observer(PushSubscribeModal);
